
import { defineComponent } from 'vue';
import { widgetType, dataKey } from '../types';

export default defineComponent({
	setup() {
		const handleDragStart = (e: DragEvent) => {
			const target = e.target as HTMLElement;
			const type = target.innerText;
			const dataTransfer = e.dataTransfer as DataTransfer;
			dataTransfer.setData(dataKey.TYPEOFADDEDWIDGET, type);
		};
		return { widgetType, handleDragStart };
	},
});
